export default "__VITE_ASSET__B1tnIPw4__"